// import xaxios from '@/xaxios';

async function getImageAsDataUri(imageUrl) {
    try {
      // Descarga la imagen como un blob
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error(`Error al cargar la imagen: ${response.statusText}`);
      }
      const blob = await response.blob();
  
      // Convierte el blob a un Data URL (base64)
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // El resultado será el Data URL
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      window.console.error("Error obteniendo la imagen:", error);
      return null;
    }
  }

function getImageType(dataUri) {
    const mimeType = dataUri.match(/^data:(.+);base64,/); // Extrae el MIME Type
    if (!mimeType) {
      return null; // No es un data URI válido
    }
    
    const type = mimeType[1]; // Captura el tipo MIME
    if (type === 'image/jpeg') {
      return 'jpg';
    } else if (type === 'image/png') {
      return 'png';
    } else {
      return 'jpg'; // Otro formato o no soportado
    }
  }

export const informar = async (portada_url, programa_name,unidad_id,programa_id) => {
    const r = await getImageAsDataUri(portada_url).then(dataUri => dataUri).catch(()=>false);
    if(r){
        const ext = getImageType(r)
        const portada = {
            filename: "portada."+ext,
            file64: r
        }
        enviar(programa_name,portada,unidad_id,programa_id);
    }else{
        enviar(programa_name,null,unidad_id,programa_id);
    }

}

/* const generateLink = async (unidad_id,programa_id) => {
    const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/unidadnegocio`;
    let res = await xaxios.get(url).then(({ data }) => data).catch((e) => e);
    let unidad = res.find((x) => x.id == unidad_id);
    
    let a1 = 'A';
    let a2 = 'B';
    let a3 = 'C';
    let a4 = 'D';
    let a5 = 'E';
    let a6 = 'F';
    let a7 = 'G';
    let a8 = 'H';
    let a9 = 'I';
    let a0 = 'J';
    let iduser = 43; // yo diego
    let tok = programa_id + '-' + iduser;
    tok = tok.replace(/1/g, a1);
    tok = tok.replace(/2/g, a2);
    tok = tok.replace(/3/g, a3);
    tok = tok.replace(/4/g, a4);
    tok = tok.replace(/5/g, a5);
    tok = tok.replace(/6/g, a6);
    tok = tok.replace(/7/g, a7);
    tok = tok.replace(/8/g, a8);
    tok = tok.replace(/9/g, a9);
    tok = tok.replace(/0/g, a0);
    let enlace = unidad.sitio_web + '/registro?t=' + tok;
    enlace = enlace.replaceAll('//r','/r');

    if(unidad_id == 5){
        enlace = `https://formulario.esamlatam.com/registro?t=${tok}`
      }
      if(unidad_id == 14){
        enlace = `https://formulario.ispi.edu.pa?t=${tok}`
      }

    return enlace;
} */

const enviar = async (nombre, portada, unidad_id,programa_id) =>{
  window.console.log('.,',nombre, portada, unidad_id,programa_id);
  

    /* const endpoint = 'https://whatsenger.sladia.com/wapi';
    const link = await generateLink(unidad_id,programa_id);

    const whatsappSendInput = {
      apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJleHAiOjE3NjU2NjUyMjYsImlhdCI6MTczNDEyOTIyNn0.hrt5dg_-UIxs5epNUKuZmLdLOvq68S01S4cWSkX4p18",
      from: "+591 78222312",
      to: "120363359997525396@newsletter",
      mensaje: `Nuevo Programa habilitado: *${nombre}* \n\n ${link}`,
      archivos: []
    };
    if(portada) whatsappSendInput.archivos.push(portada);
    
    const whatsappSendQuery = {
      query: `
        mutation whatsapp_send($input: SendMensaje!) {
          whatsapp_send(input: $input) {
            id
            mensaje
            to
          }
        }
      `
    };
    
    const data = JSON.stringify({
      query: whatsappSendQuery.query,
      variables: {
        input: whatsappSendInput
      }
    });
    
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: data
    };
    
    fetch(endpoint, config)
      .then(response => response.json())
      .then(result => {
        window.console.log(JSON.stringify(result));
      })
      .catch(error => {
        window.console.error('Error:', error);
      }); */
}